import React from 'react';

import * as styles from './style.css';

interface IPhonesPreloaderProps {
  height?: number;
}

const DEFAULT_HEIGHT = 28;

export const PhonesPreloader = ({ height }: IPhonesPreloaderProps) => {
  const style = React.useMemo(() => {
    return {
      height: `${height ?? DEFAULT_HEIGHT}px`,
    };
  }, [height]);

  return <div className={styles['loader']} style={style}></div>;
};
